// stores/initStore.ts
import { makeAutoObservable } from "mobx";
import userStore from "./userStore";

class initStore {
  isInit = true

  constructor () {
    makeAutoObservable(this);
  }

  init = async () => {

    try {
      this.isInit = true
      await userStore.getUser()

    } finally {
      this.isInit = false
    }
  }
}

export default  new initStore()
